import { Button, Card, Form, Input, message, Select, Tabs } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import styles from './PesertaFormEdit.module.css'

// REDUX
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUser } from '../../../../redux/user/user.selectors'
import { removeCurrentUser } from '../../../../redux/user/user.action'

import { useNavigate, useParams } from 'react-router-dom'
import { FetchLoading } from '../../../../components'
import { Option } from 'antd/lib/mentions'

const { TabPane } = Tabs

message.config({
  maxCount: 1,
})

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: '${label} harus diisi!',
}
/* eslint-enable no-template-curly-in-string */

const PesertaFormEdit = ({ title = '' }) => {
  const [loading, setLoading] = useState(true)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [pesertaData, setPesertaData] = useState(null)
  const [statusPeserta, setStatusPeserta] = useState(null)
  const [statusData, setStatusData] = useState(null)
  const dispatch = useDispatch()
  const { slug } = useParams()

  const navigate = useNavigate()
  const currentUser = useSelector(selectCurrentUser)
  const [form] = Form.useForm()

  useEffect(() => {
    axios({
      method: 'get',
      url: `/peserta/${slug}`,
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    })
      .then(({ data }) => {
        setStatusData(data.status)
        setPesertaData(data.user)
        setStatusPeserta(data.user.status_user)
        setLoading(false)
      })
      .catch((error) => {
        if (error.response.status === 404) {
          message.error('404 Not Found')
        }
        if (error.response.status === 401) {
          message.error('401 Unauthorized')
          dispatch(removeCurrentUser())
          navigate('/login')
        }
        if (error.response.status === 500) {
          message.error('500 Internal Server Error')
        }
        if (error.response.status === 403) {
          error.response.data.message
            ? message.error(error.response.data.message)
            : message.error('403 Forbidden')
        }
        setSubmitLoading(false)
      })
  }, [currentUser.token, dispatch, navigate, slug])

  const onFinish = (values) => {
    setSubmitLoading(true)
    const {
      name,
      username,
      email,
      city,
      address,
      zip_code,
      phone,
      status,
      university,
      class_year,
      major,
      company,
      position,
      old_password,
      password,
      password_confirmation,
    } = values

    const data = JSON.stringify({
      name,
      username,
      email,
      city,
      address,
      zip_code,
      phone,
      status,
      university,
      class_year,
      major,
      company,
      position,
      old_password,
      password,
      password_confirmation,
    })

    axios({
      method: 'patch',
      url: `/peserta/${slug}`,
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
        'Content-Type': 'application/json',
      },
      data: data,
    })
      .then((response) => {
        if (response.data.status === false) {
          message.error('Gagal Update Peserta, Periksa Kembali')
          setSubmitLoading(false)
        } else {
          form.resetFields()
          message.success('Peserta Berhasil DiUpdate')
          navigate('/peserta')
        }
      })
      .catch((error) => {
        if (error.response.status === 404) {
          message.error('404 Not Found')
        }
        if (error.response.status === 401) {
          message.error('401 Unauthorized')
          dispatch(removeCurrentUser())
          navigate('/login')
        }
        if (error.response.status === 500) {
          message.error('500 Internal Server Error')
        }
        if (error.response.status === 403) {
          message.error('403 Forbidden')
        }
        setSubmitLoading(false)
      })
  }

  return (
    <FetchLoading data={pesertaData}>
      <div className={styles.container}>
        <div className={styles.card}>
          <h1 className={styles.title}>{title}</h1>
          {!loading && (
            <Tabs defaultActiveKey="1">
              <TabPane tab="Data Pengguna" key="1">
                <Form
                  form={form}
                  layout={'vertical'}
                  onFinish={onFinish}
                  validateMessages={validateMessages}
                  initialValues={{
                    name: pesertaData.name,
                    username: pesertaData.username,
                    email: pesertaData.email,
                    city: pesertaData.city,
                    address: pesertaData.address,
                    zip_code: pesertaData.zip_code,
                    phone: pesertaData.phone,
                    status: pesertaData.status,
                    university: statusPeserta ? statusPeserta.university : '',
                    class_year: statusPeserta ? statusPeserta.class_year : '',
                    major: statusPeserta ? statusPeserta.major : '',
                    company: statusPeserta ? statusPeserta.company : '',
                    position: statusPeserta ? statusPeserta.position : '',
                  }}>
                  <Form.Item
                    label="Nama"
                    name="name"
                    rules={[
                      {
                        required: true,
                      },
                    ]}>
                    <Input placeholder="Nama" size="large" />
                  </Form.Item>
                  <Form.Item
                    label="Username"
                    name="username"
                    rules={[
                      {
                        required: true,
                      },
                    ]}>
                    <Input placeholder="Username" size="large" />
                  </Form.Item>
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      {
                        type: 'email',
                        message: 'Email Tidak Valid',
                      },
                      {
                        required: true,
                      },
                    ]}>
                    <Input placeholder="Email" size="large" />
                  </Form.Item>
                  <Form.Item
                    label="Kota"
                    name="city"
                    rules={[
                      {
                        required: true,
                      },
                    ]}>
                    <Input placeholder="Kota" size="large" />
                  </Form.Item>
                  <Form.Item
                    label="Alamat"
                    name="address"
                    rules={[
                      {
                        required: true,
                      },
                    ]}>
                    <Input placeholder="Alamat" size="large" />
                  </Form.Item>
                  <Form.Item
                    label="Kode Pos"
                    name="zip_code"
                    rules={[
                      {
                        required: true,
                      },
                    ]}>
                    <Input placeholder="Kode Pos" size="large" />
                  </Form.Item>
                  <Form.Item
                    label="Nomor Telepon"
                    name="phone"
                    rules={[
                      {
                        required: true,
                      },
                    ]}>
                    <Input placeholder="Nomor Telepon" size="large" />
                  </Form.Item>
                  <Form.Item
                    label="Status"
                    name="status"
                    rules={[{ required: true }]}>
                    <Select placeholder="Pilih Status Peserta" size="large">
                      {statusData.map((item) => (
                        <Option value={item.id_status} key={item.id_status}>
                          {item.nama}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) =>
                      prevValues.status !== currentValues.status
                    }>
                    {({ getFieldValue }) =>
                      getFieldValue('status') === 'mahasiswa' ||
                      getFieldValue('status') === 'freshgraduate' ? (
                        <Card style={{ marginBottom: 20 }}>
                          <Form.Item
                            label="Universitas"
                            name="university"
                            // initialValue={statusPeserta.university}
                            rules={[{ required: true }]}>
                            <Input placeholder="Universitas" size="large" />
                          </Form.Item>
                          <Form.Item
                            label="Tahun Masuk"
                            name="class_year"
                            // initialValue={statusPeserta.class_year}
                            rules={[{ required: true }]}>
                            <Input placeholder="Tahun Masuk" size="large" />
                          </Form.Item>
                          <Form.Item
                            label="Jurusan"
                            name="major"
                            // initialValue={statusPeserta.major}
                            rules={[{ required: true }]}>
                            <Input placeholder="Jurusan" size="large" />
                          </Form.Item>
                        </Card>
                      ) : null
                    }
                  </Form.Item>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) =>
                      prevValues.status !== currentValues.status
                    }>
                    {({ getFieldValue }) =>
                      getFieldValue('status') === 'bekerja' ? (
                        <Card style={{ marginBottom: 20 }}>
                          <Form.Item
                            label="Perusahaan"
                            name="company"
                            // initialValue={statusPeserta.company}
                            rules={[{ required: true }]}>
                            <Input placeholder="Perusahaan" size="large" />
                          </Form.Item>
                          <Form.Item
                            label="Posisi"
                            name="position"
                            // initialValue={statusPeserta.position}
                            rules={[{ required: true }]}>
                            <Input placeholder="Tahun Masuk" size="large" />
                          </Form.Item>
                        </Card>
                      ) : null
                    }
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={submitLoading}>
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </TabPane>
              <TabPane tab="Ganti Password" key="2">
                <Form
                  form={form}
                  layout={'vertical'}
                  onFinish={onFinish}
                  validateMessages={validateMessages}>
                  <Form.Item
                    label="Password Lama"
                    name="old_password"
                    rules={[
                      {
                        required: true,
                        min: 8,
                        message: 'Minimal 8 Karakter',
                      },
                    ]}>
                    <Input.Password placeholder="Password Lama" size="large" />
                  </Form.Item>
                  <Form.Item
                    label="Password"
                    name="password"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        min: 8,
                        message: 'Minimal 8 Karakter',
                      },
                    ]}>
                    <Input.Password placeholder="Password" size="large" />
                  </Form.Item>
                  <Form.Item
                    label="Konfirmasi Password"
                    name="password_confirmation"
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        min: 8,
                        message: 'Minimal 8 Karakter',
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('password') === value) {
                            return Promise.resolve()
                          }

                          return Promise.reject(
                            new Error(
                              'Password yang anda masukkan tidak sesuai'
                            )
                          )
                        },
                      }),
                    ]}>
                    <Input.Password
                      placeholder="Konfirmasi Password"
                      size="large"
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={submitLoading}>
                      Ubah Password
                    </Button>
                  </Form.Item>
                </Form>
              </TabPane>
            </Tabs>
          )}
        </div>
      </div>
    </FetchLoading>
  )
}

export default PesertaFormEdit
